import { createSlice } from "@reduxjs/toolkit";
import { DashboardResponse, SubscriptionResponse } from "src/store/types";
import {
  doFetchData,
  doFetchSubscriptionList,
  doUpdateSubscription,
} from "./dashboard.action";

interface DashboardState {
  data: DashboardResponse["data"] | null;
  subscriptionList: SubscriptionResponse["data"][] | null;
  loading: boolean;
  error: string | null;
}

const initialState: DashboardState = {
  data: null,
  subscriptionList: null,
  loading: false,
  error: null,
};

const DashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(doFetchData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doFetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(doFetchData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    builder
      .addCase(doFetchSubscriptionList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doFetchSubscriptionList.fulfilled, (state, action) => {
        state.loading = false;
        state.subscriptionList = action.payload;
      })
      .addCase(doFetchSubscriptionList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    builder
      .addCase(doUpdateSubscription.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doUpdateSubscription.fulfilled, (state, action) => {
        state.loading = false;
        // Update the specific item in the array if subscriptionList exists
        if (state.subscriptionList && Array.isArray(state.subscriptionList)) {
          const updatedItem = action.payload;
          const index = state.subscriptionList.findIndex(
            (item) => item.seId === updatedItem.seId
          );
          if (index !== -1) {
            state.subscriptionList[index] = updatedItem;
          } else {
            // If not found, replace the entire list (in case API returns array)
            state.subscriptionList = Array.isArray(action.payload)
              ? action.payload
              : [action.payload];
          }
        } else {
          // If subscriptionList is null, set it
          state.subscriptionList = Array.isArray(action.payload)
            ? action.payload
            : [action.payload];
        }
      })
      .addCase(doUpdateSubscription.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default DashboardSlice.reducer;
